import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import difference from 'ramda/es/difference'
import sortBy from 'ramda/es/sortBy'
import prop from 'ramda/es/prop'
import { persistPiniaSlice, loadPiniaSlice } from '../persist'

const sortByTitel = sortBy(prop('titel'))

export const useProfessionsStore = defineStore('professions', () => {
    const allProfessions = ref([])
    const subscribedProfessions = ref([])
    const selectedProfession = ref(undefined)

    const persist = () => {
        persistPiniaSlice('professionsStore', {
            allProfessions: allProfessions.value,
            subscribedProfessions: subscribedProfessions.value,
            selectedProfession: selectedProfession.value,
        })
    }

    const getProfessionById = (id) =>
        allProfessions.value.find((p) => p.id == id)

    const isSubscribedTo = (id) =>
        subscribedProfessions.value.some((p) => p.id == id)

    const notSubscribedProfessions = computed(() =>
        difference(allProfessions.value, subscribedProfessions.value)
    )

    const allProfessionsEmpty = computed(() => allProfessions.value.length <= 0)

    const initProfessions = (professions) => {
        subscribedProfessions.value = []
        allProfessions.value = sortByTitel(professions ? professions : [])
        persist()
    }

    const selectProfession = (profession) => {
        selectedProfession.value = profession
        persist()
    }

    const selectProfessionById = (id) => {
        selectedProfession.value = getProfessionById(id)
        persist()
    }

    const subscribeToProfession = (profession) => {
        if (subscribedProfessions.value.find((p) => p.id == profession.id)) return
        subscribedProfessions.value.push(profession)
        subscribedProfessions.value = sortByTitel(subscribedProfessions.value)
        allProfessions.value = allProfessions.value.filter(
            (p) => p.id != profession.id
        )
        allProfessions.value.push(profession)
        persist()
    }

    const subscribeToProfessionById = (id) => {
        subscribeToProfession(getProfessionById(id))
    }

    const initSubscribedProfessions = (professions) => {
        professions.forEach((p) => subscribeToProfession(p))
    }

    const saved = loadPiniaSlice('professionsStore')
    if (saved) {
        if (Array.isArray(saved.allProfessions)) {
            allProfessions.value = saved.allProfessions
        }
        if (Array.isArray(saved.subscribedProfessions)) {
            subscribedProfessions.value = saved.subscribedProfessions
        }
        if (Object.prototype.hasOwnProperty.call(saved, 'selectedProfession')) {
            selectedProfession.value = saved.selectedProfession
        }
    }

    return {
        allProfessions,
        subscribedProfessions,
        selectedProfession,
        notSubscribedProfessions,
        allProfessionsEmpty,
        getProfessionById,
        isSubscribedTo,
        initProfessions,
        initSubscribedProfessions,
        selectProfession,
        selectProfessionById,
        subscribeToProfession,
        subscribeToProfessionById,
    }
})
